import type { CSSProperties } from 'react'
import * as m from '../paraglide/messages'
import type { locales } from '../paraglide/runtime'

// MO4, operator decision 2026-10-09 (B 283): the contact checkbox conflated
// information with consent. All three forms now identify controller and purpose before the links.
export function ContactPrivacyNotice({
  locale,
  style,
}: {
  locale?: (typeof locales)[number]
  style?: CSSProperties
}) {
  return (
    <p style={{ margin: '12px 0', fontSize: 12, lineHeight: 1.5, ...style }}>
      {m.contact_notice_before_kvkk({}, { locale })}
      <a href="/kvkk" target="_blank" rel="noopener noreferrer" style={linkStyle}>
        {m.contact_notice_kvkk({}, { locale })}
      </a>
      {m.contact_notice_between_links({}, { locale })}
      <a href="/kullanim-kosullari" target="_blank" rel="noopener noreferrer" style={linkStyle}>
        {m.contact_notice_terms({}, { locale })}
      </a>
      {m.contact_notice_after_terms({}, { locale })}
    </p>
  )
}

const linkStyle: CSSProperties = { color: '#FF8C33', textDecoration: 'underline' }
